import { Outlet } from "react-router-dom";

export function EmptyCask() {
  return (
    <>
      <Outlet />
    </>
  );
}
